import { render, staticRenderFns } from "./Typeahead.vue?vue&type=template&id=4be9436e"
import script from "./Typeahead.vue?vue&type=script&lang=js"
export * from "./Typeahead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports